import React, { ReactNode, useEffect, useState } from 'react';

import { Box, TextFieldProps } from '@mui/material';

import {
  FormLabel,
  Icon,
  InputAdornment,
  TextField,
  useTransformInputValue,
} from '@sbv-clients/ui-shared';

export function BaseInput({
  placeHolder,
  label,
  q,
  writeQ,
  multiline,
  type = 'search',
  rows,
  error,
  helperText,
  style,
  height,
}: {
  q: string;
  writeQ: (value: string) => void;
  placeHolder?: string;
  label?: string;
  multiline?: boolean;
  type?: TextFieldProps['type'];
  rows?: number;
  error?: boolean;
  helperText?: ReactNode;
  style?: Record<string, string | Record<string, string>>;
  height?: string;
}) {
  const [value, setValue] = useState(q);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value !== q) {
        writeQ(value);
      }
    }, 770);

    return () => {
      clearTimeout(handler);
    };
  }, [value, writeQ]);

  useEffect(() => {
    setValue(q);
  }, [q]);

  const onChange = useTransformInputValue(setValue);

  return (
    <Box>
      <FormLabel>{label}</FormLabel>
      <TextField
        fullWidth
        multiline={multiline}
        rows={rows}
        value={value}
        onChange={(event) => {
          onChange(event as any);
        }}
        InputProps={{
          startAdornment:
            type === 'search' ? (
              <InputAdornment position="start">
                <Icon name={'Search'} />
              </InputAdornment>
            ) : null,
          sx: {
            height: height ?? '32px',
            '& input': {
              height: height ?? '32px',
            },
          },
        }}
        placeholder={`${placeHolder ? placeHolder : 'Search'}...`}
        type={type}
        size={'small'}
        error={error}
        helperText={helperText}
        sx={style}
      />
    </Box>
  );
}
